import { Users, MapPin, Headphones, Award } from "lucide-react";

const icons = {
  "Dedicated Professionals": Users,
  "States Covered": MapPin,
  "Cases Supported": Headphones,
  "Years Average Experience": Award,
};

export default function TeamPhoto({ info }) {
  return (
    <div className="relative h-[260px] overflow-hidden rounded-[18px] border border-white/10 bg-[#0B1322]">
      <img
        src={info.image}
        alt="ClaimPro Team"
        className="absolute inset-0 h-full w-full object-cover object-center"
      />

      <div
        className="
          absolute inset-y-0 left-0 w-[380px]
          bg-gradient-to-r from-[#020617] via-[#020617]/90 to-transparent
        "
      />

      <div className="relative z-10 flex h-full max-w-[320px] flex-col justify-center px-3 py-6">
        <h3 className="text-[17px] px-2 font-black uppercase leading-tight text-white">
          {info.title}
        </h3>
        <p className="mt-0.5 px-2 text-[13px] font-semibold uppercase text-[#21A6E9]">
          {info.subtitle}
        </p>

        <div className="mt-4 grid grid-cols-2 border-t border-white/15">
          {info.stats.map((item, i) => {
            const Icon = icons[item.label];
            const isLeftCol = i % 2 === 0;
            const isTopRow = i < 2;
            return (
              <div
                key={item.label}
                className={`
                  flex items-center gap-2 px-1 py-3
                  ${!isLeftCol ? "border-l border-beige" : ""}
                  ${!isTopRow ? "border-t border-white/40" : ""}
                `}
              >
                <div className="flex h-7 w-7 shrink-0 items-center justify-center rounded-full border border-white/20">
                  {Icon && <Icon size={14} className="text-[#21A6E9]" />}
                </div>
                <div className="flex flex-col">
                  <h4 className="text-[15px] font-bold leading-none text-[#21A6E9]">
                    {item.value}
                  </h4>
                  <p className="mt-1 text-[10px] leading-3.5 text-slate-300">
                    {item.label}
                  </p>
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
}